import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { toast } from 'sonner';

function Register() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    full_name: '',
    phone_number: '',
    user_type: 'golfer'
  });
  const [requiresOTP, setRequiresOTP] = useState(false);
  const [otp, setOtp] = useState('');
  const [otpForDev, setOtpForDev] = useState('');
  const [otpIdentifier, setOtpIdentifier] = useState('');
  const [loading, setLoading] = useState(false);

  /*const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await authAPI.register(formData);
      setRequiresOTP(true);
      //setOtpForDev(response.data.otp_for_dev);
      //toast.success('Registration successful! Please verify OTP.');
      setOtpForDev(response.data.otp_for_dev || '');
      toast.success(response.data.message || 'Registration successful! OTP sent via SMS.');
      console.log('DEV OTP:', response.data.otp_for_dev);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };*/

  const handleRegister = async (e) => {
   e.preventDefault();
   setLoading(true);

   try {
     const response = await authAPI.register(formData);
     setRequiresOTP(true);
     setOtpIdentifier(response.data.identifier || formData.phone_number);
     setOtpForDev(response.data.otp_for_dev || '');
     toast.success(response.data.message || 'Registration successful! Please verify OTP.');

     if (response.data.otp_for_dev) {
       console.log('DEV OTP:', response.data.otp_for_dev);
     }
   } catch (error) {
     toast.error(error.response?.data?.detail || 'Registration failed');
   } finally {
     setLoading(false);
   }
 };

  /*const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      //const response = await authAPI.verifyOTP({ email: formData.email, otp });
      const response = await authAPI.verifyOTP({
 	 identifier: otpIdentifier || formData.phone_number || formData.email,
  	otp
     });
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      toast.success('Account verified! Welcome to CaddiePay!');
      
      // Redirect based on user type
      if (response.data.user.user_type === 'admin') {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Invalid OTP');
    } finally {
      setLoading(false);
    }
  };*/

  const handleVerifyOTP = async (e) => {
   e.preventDefault();
   setLoading(true);

   try {
     const response = await authAPI.verifyOTP({
       identifier: otpIdentifier || formData.phone_number,
       otp
     });

     localStorage.setItem('token', response.data.access_token);
     localStorage.setItem('user', JSON.stringify(response.data.user));
     toast.success('Account verified! Welcome to CaddiePay!');
    
     // Redirect based on user type
     if (response.data.user.user_type === 'admin') {
       navigate('/admin');
     } else {
       navigate('/dashboard');
     }
   } catch (error) {
     toast.error(error.response?.data?.detail || 'Invalid OTP');
   } finally {
     setLoading(false);
   }
 };

  return (
    <div className="min-h-screen flex">
      <div className="hidden lg:flex lg:w-1/2 relative overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.pexels.com/photos/5044378/pexels-photo-5044378.jpeg)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-900/90 to-emerald-700/80" />
        <div className="relative z-10 flex flex-col justify-center p-12 text-white">
          <h1 className="text-5xl font-bold mb-4">Join CaddiePay</h1>
          <p className="text-xl text-emerald-100">Seamless digital payments for golfers and caddies</p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <Card className="w-full max-w-md border-slate-200 shadow-lg">
          <CardHeader>
            <CardTitle className="text-3xl">Create Account</CardTitle>
            <CardDescription>Get started with CaddiePay today</CardDescription>
          </CardHeader>
          <CardContent>
            {!requiresOTP ? (
              <form onSubmit={handleRegister} className="space-y-4" data-testid="register-form">
                <div className="space-y-2">
                  <Label htmlFor="full_name" className="text-sm font-semibold text-slate-700">Full Name</Label>
                  <Input
                    id="full_name"
                    type="text"
                    placeholder="John Doe"
                    value={formData.full_name}
                    onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
                    required
                    className="input-field"
                    data-testid="fullname-input"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="email" className="text-sm font-semibold text-slate-700">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    className="input-field"
                    data-testid="email-input"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="phone" className="text-sm font-semibold text-slate-700">Phone Number</Label>
                  <Input
                    id="phone"
                    type="tel"
                    placeholder="+27821234567"
                    value={formData.phone_number}
                    onChange={(e) => setFormData({ ...formData, phone_number: e.target.value })}
                    required
                    className="input-field"
                    data-testid="phone-input"
                  />
                </div>
                <div className="space-y-2">
                  <Label htmlFor="user_type" className="text-sm font-semibold text-slate-700">I am a...</Label>
                  <Select value={formData.user_type} onValueChange={(value) => setFormData({ ...formData, user_type: value })}>
                    <SelectTrigger className="input-field" data-testid="usertype-select">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="golfer" data-testid="golfer-option">Golfer</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-2">
                  <Label htmlFor="password" className="text-sm font-semibold text-slate-700">Password</Label>
                  <Input
                    id="password"
                    type="password"
                    placeholder="••••••••"
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    required
                    minLength={6}
                    className="input-field"
                    data-testid="password-input"
                  />
                </div>
                <Button type="submit" className="w-full btn-primary" disabled={loading} data-testid="register-submit-btn">
                  {loading ? 'Creating account...' : 'Sign Up'}
                </Button>
              </form>
            ) : (
              <form onSubmit={handleVerifyOTP} className="space-y-6" data-testid="otp-verification-form">
                <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4">
                  <p className="text-sm text-emerald-900 font-medium">OTP sent to {otpIdentifier || formData.phone_number}</p>
                  {otpForDev && (
                    <p className="text-xs text-emerald-700 mt-2">Dev OTP: <span className="font-mono font-bold">{otpForDev}</span></p>
                  )}
                </div>
                <div className="space-y-2">
                  <Label htmlFor="otp" className="text-sm font-semibold text-slate-700">Enter OTP</Label>
                  <Input
                    id="otp"
                    type="text"
                    placeholder="123456"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    required
                    maxLength={6}
                    className="input-field font-mono text-center text-2xl tracking-widest"
                    data-testid="otp-input"
                  />
                </div>
                <Button type="submit" className="w-full btn-primary" disabled={loading} data-testid="verify-otp-btn">
                  {loading ? 'Verifying...' : 'Verify & Complete Registration'}
                </Button>
              </form>
            )}

            <div className="mt-6 text-center">
              <p className="text-sm text-slate-600">
                Already have an account?{' '}
                <Link to="/login" className="text-emerald-900 font-semibold hover:underline">
                  Sign in
                </Link>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default Register;
